export const checkString = async (value: string, errStr: string): Promise<string> => {
  return value.length > 0 ? '' : errStr
}
